module.exports = __webpack_public_path__ + "img/happy.800c74d5.png";